import { useContext } from 'react';

import { InterventionProtocolContext } from '../context';
import { InterventionProtocolContextProps } from '../context/types';

export function useInterventionProtocol(): InterventionProtocolContextProps {
    return useContext(InterventionProtocolContext);
}
